import Logger from './lib/logger';
import HomeFloatingIconModal from './partials/HomeFloatingIconModal';

const NAME = 'GlobalFloatingIcon';

const init = () => {
	Logger.info(`${NAME} > init`);
	const homeFloatingIconModal = new HomeFloatingIconModal();
	homeFloatingIconModal.init();
};

init();

Logger.log(`${NAME} > loaded`);
